import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "./Logo";

export default function Loader() {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 1800);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-[999999] bg-black flex items-center justify-center overflow-hidden"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
          data-testid="site-loader"
        >
          <div className="absolute inset-0 carbon-fiber opacity-40" />
          <div className="sim-loader-bar" />
          <div className="relative z-10 text-center flex flex-col items-center">
            <motion.div
              initial={{ scale: 0.7, opacity: 0, rotate: -20 }}
              animate={{ scale: 1, opacity: 1, rotate: 0 }}
              transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
              style={{ filter: "drop-shadow(0 0 22px rgba(227,27,35,0.55)) drop-shadow(0 0 32px rgba(0,140,255,0.35))" }}
            >
              <img src={LOGO_URL} alt="SIM EXPERIENCE" className="w-28 h-28 md:w-40 md:h-40 rounded-full object-cover" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="overline mt-6 text-neutral-400"
            >
              carregando experiência
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
